import { render, staticRenderFns } from "./services-echart.vue?vue&type=template&id=324a402a&scoped=true&"
import script from "./services-echart.vue?vue&type=script&lang=js&"
export * from "./services-echart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324a402a",
  null
  
)

export default component.exports